/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';

export const Notifications = styled.div`
  position: absolute;

  // Consider the space taken by the top bar
  top: 47px;
  right: 0;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 15px;

  a {
    color: var(--tooltip-link) !important;

    &:hover {
      color: var(--tooltip-link) !important;
    }
  }
`;
